import React from 'react';
var DEFAULT_SCREEN_MOBILE = 0;
var DEFAULT_SCREEN_TABLET = 768;
var DEFAULT_SCREEN_NORMAL = 992;
var DEFAULT_SCREEN_WIDE = 1240;
var DEFAULT_SCREEN_HUGE = 2000;
export var SCREEN_MOBILE = 'SCREEN_MOBILE';
export var SCREEN_TABLET = 'SCREEN_TABLET';
export var SCREEN_NORMAL = 'SCREEN_NORMAL';
export var SCREEN_WIDE = 'SCREEN_WIDE';
export var SCREEN_HUGE = 'SCREEN_HUGE';
var defaultValue = {
  screenSizes: {
    SCREEN_MOBILE: DEFAULT_SCREEN_MOBILE,
    SCREEN_TABLET: DEFAULT_SCREEN_TABLET,
    SCREEN_NORMAL: DEFAULT_SCREEN_NORMAL,
    SCREEN_WIDE: DEFAULT_SCREEN_WIDE,
    SCREEN_HUGE: DEFAULT_SCREEN_HUGE
  },
  imageStyles: {
    SCREEN_MOBILE: 'small',
    SCREEN_TABLET: 'small',
    SCREEN_NORMAL: 'medium',
    SCREEN_WIDE: 'large',
    SCREEN_HUGE: 'large'
  }
};
var ViewportContext = /*#__PURE__*/React.createContext(defaultValue);
export default ViewportContext;